<template>
    <a-drawer
        :title="id === 0 ? 'Añadir nuevo artículo' : 'Editar artículo #' + id"
        :width="420"
        :visible="visible"
        :wrap-style="{ height: '100%', overflow: 'auto', paddingBottom: '108px' }"
        @close="$emit('close')"
    >
        <validation-observer v-slot="{ passes, invalid }">
            <form @submit="passes(save)">
                <div class="row">
                    <div class="col">
                        <g-field v-model="fields.name" :app="app" :item="id" name="name" title="Nombre" />
                    </div>

                    <div class="col">
                        <g-field v-model="fields.code" :app="app" :item="id" name="code" title="Código" />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field v-model="fields.edi_code" :app="app" :item="id" name="edi_code" title="Código EDI" />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field v-model="fields.iva" :app="app" :item="id" name="iva" title="IVA" />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field v-model="fields.surcharge" :app="app" :item="id" name="surcharge" title="Recargo" />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field v-model="fields.order" :app="app" :item="id" name="order" title="Orden" />
                    </div>
                </div>

                <div
                    :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        padding: '10px 16px',
                        textAlign: 'right',
                    }"
                >
                    <a-button :style="{ marginRight: '8px' }" @click="$emit('close')"> Cancelar </a-button>
                    <a-button type="primary" html-type="submit" :loading="loading" :disabled="invalid">
                        {{ id === 0 ? 'Añadir' : 'Modificar' }}
                    </a-button>
                </div>
            </form>
        </validation-observer>
    </a-drawer>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        id: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            view: 'articleList',
            app: 'articles',
            loading: false,
            fields: {
                name: '',
                iva: '',
                surcharge: 0,
                code: 0,
                edi_code: '',
                order: '',
            },
        }
    },
    methods: {
        async save() {
            this.loading = true

            let data
            if (this.id > 0) {
                data = await this.$gestios.items('articles').edit({ id: this.id, params: this.fields })
            } else {
                data = await this.$gestios.items('articles').add({ params: this.fields, view: this.view })
            }

            if (data.ok) this.$emit('close')

            this.loading = false
        },
    },
}
</script>

<style></style>
